import { MaintenanceForwardingSectionsProps } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import MaintenanceWorkflowForwardingCheckinEntry from "../../sections/CheckinEntry";
import MaintenanceWorkflowForwardingDirectiveEntry from "../../sections/DirectiveEntry";

const MaintenanceWorkflowForwardingOnGoingCheckin = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  return (
    <div className="flex-1 overflow-auto flex flex-col gap-4">
      <MaintenanceWorkflowForwardingCheckinEntry
        forwarding={forwarding}
        allowTransportAutoEntriesComplete
      />

      <MaintenanceWorkflowForwardingDirectiveEntry
        forwarding={forwarding}
      />
    </div>
  );
}

export default MaintenanceWorkflowForwardingOnGoingCheckin;
